import UTIL from '../../lib/util'
import { isSentry } from '../../lib/lib'

const resetFullView = videoRemoteList => {
  return videoRemoteList.map(user => {
    return {
      ...user,
      full: false
    }
  })
}

const initialState = {
  tableList: [],
  raiseList: [],
  remoteList: [],
  groupList: [],
  groupListObj: {},
  videoRemoteList: []
}

const breakoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_HEAR':
      var videoRemoteList = state.videoRemoteList
      for (var i = 0; i < videoRemoteList.length; i++) {
        videoRemoteList[i]['key'] = UTIL.makeid()
        if (parseInt(videoRemoteList[i]['group']) === action.group) {
          videoRemoteList[i]['hear'] = action.hear
        }
      }
      return Object.assign({}, state, {videoRemoteList: videoRemoteList})
    case 'INIT_REMOTE_USER':
      var remoteList = action.user
      return Object.assign({}, state, {remoteList: remoteList})
    case 'ADD_REMOTE_USER':
      var remoteList = [...state.remoteList, action.user]
      return Object.assign({}, state, {remoteList: remoteList})
    case 'DELETE_REMOTE_USER':
      var remoteList = state.remoteList
      for (var i = 0; i < remoteList.length; i++) {
        if (remoteList[i].uid === action.user.uid) {
          remoteList.splice(i, 1)
          break
        }
      }
      return Object.assign({}, state, {remoteList: remoteList})
    case 'UPDATE_REMOTE_USER':
      var remoteList = state.remoteList
      for (var i = 0; i < remoteList.length; i++) {
        if (remoteList[i].uid === action.user.uid) {
          remoteList[i] = action.user
          break
        }
      }
      return Object.assign({}, state, {remoteList: remoteList})
    case 'UPDATE_STREAM':
      var videoRemoteList = state.videoRemoteList
      for (var i = 0; i < videoRemoteList.length; i++) {
        if (videoRemoteList[i].id === action.user.id) {
          videoRemoteList[i].stream = action.user.stream
          videoRemoteList[i].key = UTIL.makeid()
          break
        }
      }
      return Object.assign({}, state, {videoRemoteList: videoRemoteList})
    case 'INIT_TABLE_USER':
      var tableList = action.user
      return Object.assign({}, state, {tableList: tableList})
    case 'ADD_TABLE_USER':
      var tableList = [...state.tableList, action.user]
      return Object.assign({}, state, {tableList: tableList})
    case 'DELETE_TABLE_USER':
      var tableList = state.tableList
      for (var i = 0; i < tableList.length; i++) {
        if (tableList[i].group === action.user.group) {
          tableList.splice(i, 1)
          break
        }
      }
      return Object.assign({}, state, {tableList: tableList})
    case 'UPDATE_TABLE_USER':
      var tableList = state.tableList
      for (var i = 0; i < tableList.length; i++) {
        if (tableList[i].group === action.user.group) {
          tableList[i] = action.user
          break
        }
      }
      return Object.assign({}, state, {tableList: tableList})
    case 'INIT_RAISE_USER':
      var raiseList = action.user
      return Object.assign({}, state, {raiseList: raiseList})
    case 'ADD_RAISE_USER':
      var raiseList = [...state.raiseList, action.user]
      return Object.assign({}, state, {raiseList: raiseList})
    case 'DELETE_RAISE_USER':
      var raiseList = state.raiseList
      for (var i = 0; i < raiseList.length; i++) {
        if (raiseList[i].uid === action.user.uid) {
          raiseList.splice(i, 1)
          break
        }
      }
      return Object.assign({}, state, {raiseList: raiseList})
    case 'UPDATE_RAISE_USER':
      var raiseList = state.raiseList
      for (var i = 0; i < raiseList.length; i++) {
        if (raiseList[i].uid === action.user.uid) {
          raiseList[i] = action.user
          break
        }
      }
      return Object.assign({}, state, {raiseList: raiseList})
    case 'INIT_GROUP_USER':
      var groupList = action.user
      var groupListObj = {}
      for (var i = 0; i < groupList.length; i++) {
        var array = groupListObj[groupList[i].group]
        if (typeof array === 'undefined') {
          groupListObj[groupList[i].group] = [groupList[i]]
        } else {
          array.push(groupList[i])
          groupListObj[groupList[i].group] = array
        }
      }
      return Object.assign({}, state, {
        groupList: groupList,
        groupListObj: groupListObj
      })
    case 'ADD_GROUP_USER':
      var groupList = [...state.groupList, action.user]
      var groupListObj = {}
      for (var i = 0; i < groupList.length; i++) {
        var array = groupListObj[groupList[i].group]
        if (typeof array === 'undefined') {
          groupListObj[groupList[i].group] = [groupList[i]]
        } else {
          array.push(groupList[i])
          groupListObj[groupList[i].group] = array
        }
      }
      return Object.assign({}, state, {
        groupList: groupList,
        groupListObj: groupListObj
      })
    case 'DELETE_GROUP_USER':
      var groupList = state.groupList
      for (var i = 0; i < groupList.length; i++) {
        if (groupList[i].uid === action.user.uid) {
          groupList.splice(i, 1)
          break
        }
      }
      var groupListObj = {}
      for (var i = 0; i < groupList.length; i++) {
        var array = groupListObj[groupList[i].group]
        if (typeof array === 'undefined') {
          groupListObj[groupList[i].group] = [groupList[i]]
        } else {
          array.push(groupList[i])
          groupListObj[groupList[i].group] = array
        }
      }
      return Object.assign({}, state, {
        groupList: groupList,
        groupListObj: groupListObj
      })
    case 'UPDATE_GROUP_USER':
      var groupList = state.groupList
      for (var i = 0; i < groupList.length; i++) {
        if (groupList[i].uid === action.user.uid) {
          groupList[i] = action.user
          break
        }
      }
      var groupListObj = {}
      for (var i = 0; i < groupList.length; i++) {
        var array = groupListObj[groupList[i].group]
        if (typeof array === 'undefined') {
          groupListObj[groupList[i].group] = [groupList[i]]
        } else {
          array.push(groupList[i])
          groupListObj[groupList[i].group] = array
        }
      }
      return Object.assign({}, state, {
        groupList: groupList,
        groupListObj: groupListObj
      })
    case 'CLEAR_REMOTE_VIDEO_USER':
      return Object.assign({}, state, {videoRemoteList: []})
    case 'DELETE_REMOTE_VIDEO_USER': {
      let full = false
      const videoRemoteList = state.videoRemoteList

      for (let i = 0; i < videoRemoteList.length; i++) {
        let obj = videoRemoteList[i]
        if (obj.id === action.user) {
          full = obj.full
          videoRemoteList.splice(i, 1)
          try {
            if (typeof obj.detach !== 'undefined') {
              obj.detach()
            }
          } catch (err) {
            isSentry(err)
          }
        }
      }
      if (full && videoRemoteList[videoRemoteList.length - 1]) {
        videoRemoteList[videoRemoteList.length - 1].full = true
      }
      return Object.assign({}, state, {videoRemoteList: videoRemoteList})
    }
    case 'ADD_REMOTE_VIDEO_USER': {
      let videoRemoteList = [...state.videoRemoteList]

      // すでに存在する場合は更新する
      const index = videoRemoteList.findIndex(
        user => user.id === action.user.id
      )
      if (index >= 0) {
        console.log('duplicate user')
        let tempArray = state.videoRemoteList.filter(val => val['id'] !== action.user.id)
        state.videoRemoteList = [...tempArray, action.user]
        return Object.assign({}, state, {videoRemoteList: videoRemoteList})
      }

      // 自分を追加する
      const videoRemoteListResult = videoRemoteList.filter(audioTag => !audioTag.audioTag)
      if (videoRemoteListResult.length === 0 && !action.user.audioTag) {
        action.user['full'] = true
        action.user['first'] = true
      }

      // 最初に自分が中央にきている状態から他の人が入室した場合
      if (videoRemoteListResult.length === 1 && !action.user.you && !action.user.audioTag) {
        videoRemoteList = resetFullView(videoRemoteList)
        action.user['full'] = true
      }

      // スクリーンシェアされた場合
      if (action.user.screen) {
        videoRemoteList = resetFullView(videoRemoteList)
        action.user['full'] = true
      }
      return Object.assign({}, state, {
        videoRemoteList: [...videoRemoteList, action.user]
      })
    }
    case 'FULL_SCREEN':
      var videoRemoteList = state.videoRemoteList
      for (var i = 0; i < videoRemoteList.length; i++) {
        videoRemoteList[i]['key'] = UTIL.makeid()
        var obj = videoRemoteList[i]
        videoRemoteList[i]['full'] = false
        if (obj.id === action.user) {
          videoRemoteList[i]['full'] = true
        }
      }
      return Object.assign({}, state, {videoRemoteList: videoRemoteList})
    case 'VIDEO_RESET':
      var videoRemoteList = state.videoRemoteList
      for (var i = 0; i < videoRemoteList.length; i++) {
        videoRemoteList[i]['key'] = UTIL.makeid()
      }
      return Object.assign({}, state, {videoRemoteList: videoRemoteList})
    case 'AUDIO_MUTE_TOGGLE':
      var videoRemoteList = state.videoRemoteList
      for (var i = 0; i < videoRemoteList.length; i++) {
        videoRemoteList[i]['key'] = UTIL.makeid()
        var obj = videoRemoteList[i]
        if (obj.id === action.user) {
          videoRemoteList[i]['mute'] = action.mute
        }
      }
      return Object.assign({}, state, {videoRemoteList: videoRemoteList})
    default:
      return state
  }
}

export default breakoutReducer



// WEBPACK FOOTER //
// ./src/routes/BreakOutMode/reducer.js